export default function initFileUpdate() {
  // --- Lógica de Troca de Formulários (Tabs) ---
  const tabButtons = document.querySelectorAll('.c-contato__forms-btn');
  const tabContents = document.querySelectorAll('.c-contato__forms-content');

  if (tabButtons.length > 0) {
    tabButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const targetId = btn.getAttribute('data-form-target');

        tabButtons.forEach(b => b.classList.remove('is-active'));
        tabContents.forEach(c => c.classList.remove('is-visible'));

        btn.classList.add('is-active');
        const targetContent = document.getElementById(targetId);
        if (targetContent) targetContent.classList.add('is-visible');
      });
    });
  }

  // --- Lógica de Nome do Arquivo Selecionado ---
  const inputFile = document.getElementById('js-file-input');
  const fileNameDisplay = document.getElementById('js-file-name');

  if (inputFile && fileNameDisplay) {
    inputFile.addEventListener('change', function () {
      if (this.files.length > 0) {
        fileNameDisplay.textContent = this.files[0].name;
      } else {
        fileNameDisplay.textContent = 'Nenhum arquivo selecionado';
      }
    });
  }
  initTabDrag();
  initFormSuccess();
  initCf7SubmitButtons();
  initInputMasks();
  document.addEventListener('wpcf7init', initInputMasks, false);
}

const PDR_INPUT_MASK_CONFIGS = [
  {
    className: 'js-mask-celular',
    inputMode: 'tel',
    maxLength: 15,
    normalize: value => String(value || '').replace(/\D/g, ''),
    format: formatCellular
  },
  {
    className: 'js-mask-cnpj',
    inputMode: 'text',
    maxLength: 18,
    normalize: value => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, ''),
    format: formatCnpj,
    validate: isValidCnpj,
    validationMessage: 'Digite um CNPJ válido.'
  },
  {
    className: 'js-mask-cep',
    inputMode: 'numeric',
    maxLength: 9,
    normalize: value => String(value || '').replace(/\D/g, ''),
    format: formatCep
  }
];

function initInputMasks() {
  const fields = document.querySelectorAll(
    'input.js-mask-celular, input.js-mask-cnpj, input.js-mask-cep'
  );

  fields.forEach((input) => {
    if (input.dataset.pdrMaskInitialized === 'true') return;

    const config = PDR_INPUT_MASK_CONFIGS.find(({ className }) => input.classList.contains(className));
    if (!config) return;

    input.dataset.pdrMaskInitialized = 'true';
    input.setAttribute('inputmode', config.inputMode);

    if (!input.hasAttribute('maxlength')) {
      input.maxLength = config.maxLength;
    }

    const applyMask = () => {
      formatMaskedInput(input, config);
      updateMaskedFieldValidity(input, config);
    };

    input.addEventListener('input', applyMask);
    input.addEventListener('change', applyMask);
    input.addEventListener('blur', () => updateMaskedFieldValidity(input, config));
    applyMask();
  });
}

function formatMaskedInput(input, config) {
  const value = input.value || '';
  const selectionStart = input.selectionStart;
  const valueBeforeCaret = selectionStart === null
    ? value
    : value.slice(0, selectionStart);
  const normalizedValue = config.normalize(value);
  const normalizedBeforeCaret = config.normalize(valueBeforeCaret);
  const formattedValue = config.format(normalizedValue);
  const formattedBeforeCaret = config.format(normalizedBeforeCaret);

  input.value = formattedValue;

  if (
    selectionStart !== null
    && document.activeElement === input
    && typeof input.setSelectionRange === 'function'
  ) {
    const nextCaret = Math.min(formattedValue.length, formattedBeforeCaret.length);
    input.setSelectionRange(nextCaret, nextCaret);
  }
}

function updateMaskedFieldValidity(input, config) {
  if (typeof config.validate !== 'function') return;

  const normalizedValue = config.normalize(input.value);
  const isValid = normalizedValue.length === 0 || config.validate(normalizedValue);

  if (typeof input.setCustomValidity === 'function') {
    input.setCustomValidity(isValid ? '' : config.validationMessage);
  }
}

function formatCellular(digits) {
  const value = digits.slice(0, 11);

  if (value.length <= 2) return value ? `(${value}` : '';
  if (value.length <= 7) return `(${value.slice(0, 2)}) ${value.slice(2)}`;

  return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
}

function formatCnpj(value) {
  const normalized = value.slice(0, 14);
  let formatted = normalized.slice(0, 2);

  if (normalized.length > 2) formatted += ` ${normalized.slice(2, 5)}`;
  if (normalized.length > 5) formatted += ` ${normalized.slice(5, 8)}`;
  if (normalized.length > 8) formatted += `/${normalized.slice(8, 12)}`;
  if (normalized.length > 12) formatted += `-${normalized.slice(12, 14)}`;

  return formatted;
}

function formatCep(digits) {
  const value = digits.slice(0, 8);

  return value.length > 5 ? `${value.slice(0, 5)}-${value.slice(5)}` : value;
}

function isValidCnpj(value) {
  const normalized = String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (!/^[A-Z0-9]{12}\d{2}$/.test(normalized)) return false;
  if (/^(.)\1+$/.test(normalized)) return false;

  const firstDigit = calculateCnpjDigit(normalized.slice(0, 12));
  const secondDigit = calculateCnpjDigit(`${normalized.slice(0, 12)}${firstDigit}`);

  return Number(normalized[12]) === firstDigit && Number(normalized[13]) === secondDigit;
}

function calculateCnpjDigit(value) {
  const weights = value.length === 12
    ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const sum = value.split('').reduce((total, character, index) => {
    return total + ((character.charCodeAt(0) - 48) * weights[index]);
  }, 0);
  const remainder = sum % 11;

  return remainder < 2 ? 0 : 11 - remainder;
}

function initTabDrag() {
  const slider = document.querySelector('.c-contato__forms-nav');
  if (!slider) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('is-dragging');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;

    e.preventDefault();
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('is-dragging');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
}

// ... (suas funções initFileUpdate e initTabDrag continuam iguais)

function initFormSuccess() {
  // Listener para SUCESSO
  document.addEventListener('wpcf7mailsent', function (event) {
    const formElement = event.target;
    const container = formElement.closest('.c-contato__forms-content');

    if (container) {
      const formWrapper = container.querySelector('.c-contato__forms-form');
      const successMessage = container.querySelector('.form-success-msg');

      if (formWrapper && successMessage) {
        formWrapper.style.display = 'none';
        successMessage.classList.remove('is-hidden');
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, false);

  // Listener para ERROS DE VALIDAÇÃO
  document.addEventListener('wpcf7invalid', function(event) {
    setTimeout(() => {
      const firstErrorField = event.target.querySelector('.wpcf7-not-valid');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }, ); 
  }, false);
}

/**
 * Mantém os botões de envio disponíveis para que o Contact Form 7 possa
 * apresentar a validação dos campos obrigatórios ao usuário.
 *
 * O CF7 desabilita o botão enquanto a caixa de aceite estiver desmarcada.
 * Isso impede qualquer clique e, consequentemente, impede que os avisos de
 * validação apareçam. A validação no servidor continua ativa: sem o aceite,
 * o formulário permanece rejeitado pelo CF7.
 */
function initCf7SubmitButtons() {
  const forms = document.querySelectorAll('.c-contato__forms-container .wpcf7 form.wpcf7-form');

  if (!forms.length) return;

  forms.forEach((form) => {
    const acceptanceInput = form.querySelector('.wpcf7-acceptance input[type="checkbox"]');
    const acceptanceWrap = acceptanceInput?.closest('.wpcf7-form-control-wrap');
    const acceptanceGroup = acceptanceInput?.closest('.c-contato-forms__group');
    const acceptanceErrorClass = 'pdr-cf7-acceptance-error';
    const acceptanceErrorMessage = 'Aceite a Política de Privacidade para enviar o formulário.';

    const enableSubmitButtons = () => {
      if (form.classList.contains('submitting')) return;

      form.querySelectorAll('.wpcf7-submit').forEach((submitButton) => {
        submitButton.disabled = false;
      });
    };

    const clearAcceptanceError = () => {
      form.querySelectorAll(`.${acceptanceErrorClass}`).forEach((error) => {
        error.remove();
      });

      if (acceptanceInput) {
        acceptanceInput.classList.remove('wpcf7-not-valid');
        acceptanceInput.setAttribute('aria-invalid', 'false');
      }
    };

    const showAcceptanceError = () => {
      if (!acceptanceInput || acceptanceInput.checked || !acceptanceWrap) return;

      clearAcceptanceError();

      const errorMessage = document.createElement('span');
      errorMessage.className = `wpcf7-not-valid-tip ${acceptanceErrorClass}`;
      errorMessage.textContent = acceptanceErrorMessage;
      acceptanceInput.classList.add('wpcf7-not-valid');
      acceptanceInput.setAttribute('aria-invalid', 'true');

      const errorContainer = acceptanceGroup || acceptanceWrap;
      errorContainer?.appendChild(errorMessage);
    };

    const showAcceptanceErrorFromSubmit = (event) => {
      const status = event.detail?.apiResponse?.status;

      if (
        'acceptance_missing' === status
        || 'unaccepted' === status
        || 'validation_failed' === status
        || 'invalid' === status
      ) {
        showAcceptanceError(event);
      }
    };

    // Corrige o estado inicial depois da inicialização do CF7.
    enableSubmitButtons();

    // O CF7 recalcula o estado após alterações e resets.
    form.addEventListener('change', enableSubmitButtons);
    form.addEventListener('wpcf7reset', enableSubmitButtons);
    form.addEventListener('wpcf7statuschanged', enableSubmitButtons);

    // Com outros campos vazios, o CF7 dispara "invalid"; quando só falta o
    // aceite, dispara "unaccepted". Os dois cenários precisam do mesmo aviso.
    form.addEventListener('wpcf7unaccepted', showAcceptanceError);
    form.addEventListener('wpcf7invalid', showAcceptanceError);
    form.addEventListener('wpcf7submit', showAcceptanceErrorFromSubmit);
    form.addEventListener('change', (event) => {
      if (event.target === acceptanceInput && acceptanceInput.checked) {
        clearAcceptanceError();
      }
    });
    form.addEventListener('wpcf7reset', clearAcceptanceError);

    // Também cobre inicializações tardias ou scripts que alterem o atributo
    // disabled depois dos listeners acima.
    const observer = new MutationObserver(enableSubmitButtons);
    observer.observe(form, {
      attributes: true,
      attributeFilter: ['disabled'],
      subtree: true
    });
  });
}
